//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getSignStatus} from '@/assets/js/dict';
import{downloadFile} from '@/assets/js/tool';
export default ({
    props:['proStates','xzState'],
    created(){
        getSignStatus().then(res=>{
            this.signList= res;
        })
    },
    data() {
        return {
            signState: false, //协议签订状态
            signList: [],
            dealInfoVisible: false,//协议详情弹窗
            zbList: [],
            dealVisible: false,
            dealStep: 1,
            contractList: [],  //协议列表
            dealForm: {
                ownerName: '', //发包商
                providerName: '', //服务商
                arbitrationAddress: '',//仲裁地
                userId: '', //用户id
            },
            contracts: '',
            contUrl: '',
            dealSign: false, //签订协议 发布项目的时候选择了,默认进入详情就要显示
            rules:{
                
            }
        }
    },
    methods: {
          // 下载文件
      downloadUrl(fileUrl,fileName){
        downloadFile(fileUrl,fileName)
      },
        // 检测协议是否签订
        checkDeal() {
            this.$get('/tra/project/contract/isSign?traProjectId=' + this.$route.query.id, function (res) {
                if (res.code == 200) {
                    this.signState = res.data;  //true 签订了 false 未签订
                }
            })
        },
        // 发起协议
        uploadDeal() {
            this.userInfo(); //中标人信息列表
            this.dealVisible = true;
            this.dealStep = 1;
            this.dealForm.arbitrationAddress = '';
            this.dealForm.userId = '';
        },

        // 获取中标人列表
        userInfo() {
            this.$get('/tra/project/bid/zbList?projectId=' + this.$route.query.id, function (res) {
                if (res.code == 200) {
                    this.zbList = res.data;
                }
            })
        },
        // 预览协议 签订协议
        nextDeal() {
            this.$put('/tra/project/contract/complete', this.contracts, function (res) {
                if (res.code == 200) {
                    this.$message.success('签订成功!');
                    this.dealVisible = false;
                    this.dealInfoVisible = false;
                    this.contractInfo(); //协议签订列表
                    this.userInfo();
                }
            }, true)
        },

        // 协议签订的列表
      contractInfo() {
        this.$get('/tra/project/contract/list?traProjectId='+this.$route.query.id+'&userType='+getSession('user').currentUserType, 
         function(res){
          if (res.code == 200) {
            this.contractList = res.data;
            for (let item of this.contractList) {
              if (item.signStatus == '0') {
                item.stepIndex = 2
              }
              if (item.signStatus == '1') {
                item.stepIndex = 4
              }
              if (item.signStatus == '3') {
                item.stepIndex = 3
              }
            }
            this.dealSign = res.data.isContract;
          }
        })
      },

        // 查看协议详情
        lookDeal(id) {
            this.traProjectContractId = id;
            this.dealInfoVisible = true;
            this.dealStep=1
            this.$get('/tra/project/contract/detail?id=' + id, function (res) {
                if (res.code == 200) {
                    this.contracts = res.data;
                    this.contracts.contractFile = res.data.fileList[0];
                    var href=''
                    if(window.location.href.indexOf('yunzikongjian')!=-1){
                        href=window.location.href.split('/wechat/#/facilitator')[0];
                    }else{
                        href=window.location.href.split('/#/facilitator')[0];
                    }
                    if (res.data.signStatus == 1) {
                        this.contUrl = href + res.data.signFileUrl
                    } else if (res.data.signStatus == 2) {
                        this.contUrl = href + res.data.confirmFileUrl
                    } else {
                        this.contUrl = href + res.data.fileList[0].fileUrl
                    }

                }
            })
        },
        // 拒绝签订
        cancelSign(row) {
            this.contracts.signStatus=3;
            this.$put('/tra/project/contract/refuse', this.contracts, function(res){
            if (res.code == 200) {
                this.$message.success('拒绝签订!');
                this.dealVisible= false;
                this.contractInfo()
            }
            },true)
        },

        // 预览协议(和发起签订是同一个弹窗,里面的变量不一样)
        lookXy() {
            this.dealVisible = true;
            this.dealStep = 2;
        },
    },
    mounted() {
        this.checkDeal()
        this.contractInfo()
    }
})
